export default __webpack_public_path__ + "assets/2c009d83c8fb9338e4807b5345cc25f5.jpeg";